import type { Address } from "viem"
import type { Config } from "wagmi"

import type { ApprovalMode, ContractRiskLevel } from "@/domains/core"
import type { TransactionReturnType } from "@/domains/on-chain/types"
import { approveOwnerSpenderAllowance, increaseLockAmount } from "@/domains/on-chain"

import type { IIncreaseLockAmountActions } from "./interfaces"

/**
 * Adapter that implements IIncreaseLockAmountActions using the actual on-chain functions.
 * This is the production implementation injected into the interaction.
 */
export class IncreaseLockAmountActionsAdapter implements IIncreaseLockAmountActions {
  async approveTokenAllowance(params: {
    account: Address
    chainId: number
    config: Config
    contractAddress: Address
    spenderAddress: Address
    spenderAmount: bigint
    approvalMode: ApprovalMode
    contractRiskLevel: ContractRiskLevel
  }): Promise<TransactionReturnType> {
    return await approveOwnerSpenderAllowance(params)
  }

  async increaseLockAmount(params: {
    account: Address
    chainId: number
    config: Config
    vestedAddress: Address
    tokenId: number
    amount: bigint
  }): Promise<TransactionReturnType> {
    return await increaseLockAmount(params)
  }
}
